<template>
  <div class="nps-answer-timeline">
		<div class="nps-timeline-list post-group">
			<div v-for="(action, index) in listOfActions" :key="`list-of-actions-${action.id || index}`" class="post-item">
				<hr v-if="index === 0" />
				<span v-if="index === 0 && action.created" class="post-date">
					Adicionado {{ action.created | moment("from", "now") }}
				</span>
				<span v-else-if="action.created" class="post-date" >
					{{ action.created | moment("DD \\d\\e MMMM \\d\\e YYYY") }} às {{ action.created | moment("HH:mm:ss") }}
				</span>
				<span v-else class="post-date">—</span>
				<p class="post-title tx-16">
					<span class="pd-r-5">{{ action.description }}</span>
				</p>
				<p class="tx-12 mg-b-10">
					Criado por: <strong style="color: #1C3B70;">{{ action.createdBy || '—' }}</strong>
				</p>
				<hr />
			</div>
			<div v-if="listOfActions.length === 0 && !loading" class="nps-timeline-empty">
				Nenhuma ação registrada.
			</div>
			<div v-if="loading" class="nps-timeline-loading">Carregando...</div>
		</div>
  </div>
</template>

<script>
import Axios from "axios";
import config from "@/config.js";

export default {
  name: "NpsAnswerTimeline",
  props: {
    answerId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      listOfActions: [],
      loading: false,
    };
  },
  watch: {
    answerId: {
      immediate: true,
      handler(val) {
        if (val != null) {
          this.load();
        } else {
          this.listOfActions = [];
        }
      },
    },
  },
  methods: {
    load() {
      if (this.answerId == null) return;
      this.loading = true;
      Axios.get(
        `${config.env.API_DEFAULT.host}/process-nps/answers/${this.answerId}/actions`
      )
        .then((response) => {
          const data = response.data;
          let list = [];
          if (Array.isArray(data)) {
            list = data;
          } else if (Array.isArray(data?.data)) {
            list = data.data;
          } else if (data?._embedded?.npsAnswerActions && Array.isArray(data._embedded.npsAnswerActions)) {
            list = data._embedded.npsAnswerActions;
          }
          this.listOfActions = [...list].sort((a, b) => {
            const dateA = a.created || "";
            const dateB = b.created || "";
            return new Date(dateB) - new Date(dateA);
          });
        })
        .catch(() => {
          this.listOfActions = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.nps-answer-timeline {
  margin-top: 12px;
}

.nps-timeline-list {
  max-height: 380px;
  overflow-y: auto;
  padding-right: 8px;

  &.post-group {
    margin-top: 10px;
  }

  /* Layout igual ao Form.Sidebar.Timeline: linha vertical + círculos azuis */
  ::v-deep .post-item {
    padding-left: 20px;
    padding-bottom: 20px;
    position: relative;
    border-left: 1px solid #dee2e6;
    margin-left: 6px;
  }

  ::v-deep .post-item::before {
    content: '';
    position: absolute;
    top: 2px;
    left: -7px;
    width: 13px;
    height: 13px;
    border-radius: 100%;
    border: 3px solid #1b84e7;
    background-color: #fff;
    z-index: 10;
  }

  ::v-deep .post-date {
    display: block;
    font-size: 12px;
    margin-bottom: 10px;
    color: #6c757d;
  }

  ::v-deep .post-title {
    margin-bottom: 2px;
    font-weight: 500;
  }

  ::v-deep .post-title a {
    color: #343a40;
  }

  ::v-deep .post-title a:hover,
  ::v-deep .post-title a:focus {
    color: #1b84e7;
  }

  ::v-deep .tx-12 {
    font-size: 12px;
    color: #6c757d;
  }

  ::v-deep .tx-12 a {
    color: #1b84e7;
  }

  ::v-deep hr {
    margin: 10px 0;
    border: 0;
    border-top: 1px solid #dee2e6;
  }
}

.nps-timeline-empty,
.nps-timeline-loading {
  padding: 16px 0;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
}
</style>
